export const GET_TENANT_USER_LIST_REQUEST = "GET_TENANT_USER_LIST_REQUEST";
export const GET_TENANT_USER_LIST_SUCCESS = "GET_TENANT_USER_LIST_SUCCESS";
export const GET_TENANT_USER_LIST_ERROR = "GET_TENANT_USER_LIST_ERROR";

export const DELETE_USER_ROW_REQUEST = "DELETE_USER_ROW_REQUEST";
export const DELETE_USER_ROW_SUCCESS = "DELETE_USER_ROW_SUCCESS";
export const DELETE_USER_ROW_ERROR = "DELETE_USER_ROW_ERROR";

export const UPDATE_USER_ROW_REQUEST = "UPDATE_USER_ROW_REQUEST";
export const UPDATE_USER_ROW_SUCCESS = "UPDATE_USER_ROW_SUCCESS";
export const UPDATE_USER_ROW_ERROR = "UPDATE_USER_ROW_ERROR";
